module.exports = __webpack_public_path__ + "img/capitol_hill_library_9604.8d29bda2.jpg";